export const getParentPageURLSegment = (
  isNews: boolean,
  isVoices: boolean,
  isCircleOfChairs: boolean,
  isPodcast: boolean
): string => {
  switch (true) {
    case isNews:
      return 'news'
    case isVoices:
      return 'voices'
    case isCircleOfChairs:
      return 'circle-of-chairs'
    case isPodcast:
      return 'podcasts'
    default:
      return 'resources'
  }
}
